module.exports = __webpack_public_path__ + "fonts/Lato-Medium.cecc32d.eot";